const ReturnHour = (date) => {
    const event = new Date(date);
    const hour = (event.getHours() < 10) ? `0${event.getHours()}` : event.getHours()
    const minute = (event.getMinutes() < 10) ? `0${event.getMinutes()}` : event.getMinutes()
    return `${hour}:${minute}`;
}

export default ReturnHour
